import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('edge', ['cachedEdges', 'selectedEdge']),
}

export const Methods = mapActions('edge', [
  'fetchEdges',
  'selectEdge',
  'updateEdge',
  'edgeById',
])
